const SignupformData = {
  firstName: {
    value: "",
    type: "text",
    label: "First Name",
    errorMsg: "This is a mandatory field",
    class: "mb-3 col-6 form-group inline margin-right mt-20",
    validation: {
      require: true,
      maxLength: 20
    },
    maxLength: "20",
    valid: true
  },
  lastName: {
    value: "",
    type: "text",
    label: "Last Name",
    errorMsg: "This is a mandatory field",
    class: "mb-3 col-6 form-group inline margin-left mt-20",
    validation: {
      require: true,
      maxLength: 20
    },
    maxLength: "20",
    valid: true
  },
  email: {
    value: "",
    readonly: true,
    label: "Email",
    type: "text",
    errorMsg: "Please enter a valid email",
    blurred: false,
    validation: {
      require: true,
      email: true,
      maxLength: 65
    },
    maxLength: "65",
    valid: true
  },
  password: {
    value: "",
    type: "password",
    label: "Password",
    errorMsg: "Please ensure your password meets the requirements above",
    passwordOption: true,
    length: "4",
    blurred: false,
    belowPlaceholder:
      "Must include an upper and lowercase letter, number and be at least 6 characters.",
    validation: {
      require: true,
      passsword: true,
      maxLength: 20
    },
    maxLength: "20",
    valid: true
  },
  confirmPassword: {
    value: "",
    type: "password",
    label: "Confirm Password",
    errorMsg: "Please make sure your passwords match",
    placeholder: "Re-enter your password",
    blurred: false,
    validation: {
      require: false,
      matchPassword: true,
      maxLength: 20
    },
    maxLength: "20",
    valid: true
  }
};

export default SignupformData;
